import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {},
  mainSection: {
    marginTop: 25,
    display: 'grid',
    width: '100%',
    gridTemplateColumns: '5fr 1fr 5fr',
    gridGap: 12,
    height: '72vh',
    [theme.breakpoints.down('xs')]: {
      display: 'flex',
      flexDirection: 'column',
      gridGap: 0
    }
  }
}))

export default useStyles
